import { FlexTableExtension } from "../flex-table";
/** @typedef {import("../flex-table").FlexTableContext} FlexTableContext */

export class CarouselScrollingExtension extends FlexTableExtension {
    constructor({ momentum } = {}) {
        super()
        this.momentum = momentum || 0.75
    }

    /**
     * Attach the fixed header extension to the context.
     * @param {FlexTableContext} flexTableContext The flex table context object
     */
    attach(flexTableContext) {
        if (this.isAttached) return
        super.attach(flexTableContext)
        this.carousel = initCarouselScrolling(this.horizontalContainer, this.momentum)
        this.verticalContainer.parentElement.insertBefore(this.carousel, this.verticalContainer)
    }

    /**
     * Detach the fixed header extension from the context.
     * @param {FlexTableContext} flexTableContext The flex table context object
     */
    detach(flexTableContext) {
        if (!this.isAttached) return
        this.carousel.remove()
        super.detach(flexTableContext)
    }
}

/**
 * Add buttons to the container that cause the container to scroll left and right.
 * @param {HTMLDivElement} scrollingContainer The DOM element that should implement scrolling behaviour.
 * @param {number} momentum The percentage of the scrolling container to cover after each scroll.
 * @returns {any} Toolbar of buttons that can be used to scroll the scrolling container.
 */
function initCarouselScrolling(scrollingContainer, momentum) {
    // TODO: Restructure to get scroll button HTML from a component or template somehow.
    const leftScroll = document.createElement("button");
    leftScroll.classList.add("apex-flex-table-carousel-left");
    leftScroll.innerHTML = "<span class='glyphicon fas fa-chevron-left'></span>";
    leftScroll.addEventListener("click", function () {
        // Scroll the entire width of the container, with some overlap.
        scrollingContainer.scrollLeft -= scrollingContainer.clientWidth * momentum;
    });

    const rightScroll = document.createElement("button");
    rightScroll.classList.add("apex-flex-table-carousel-right");
    rightScroll.innerHTML = "<span class='glyphicon fas fa-chevron-right'></span>";
    rightScroll.addEventListener("click", function () {
        scrollingContainer.scrollLeft += scrollingContainer.clientWidth * momentum;
    });

    const stickyToolbar = document.createElement("div");
    stickyToolbar.classList.add("apex-flex-table-carousel-toolbar");
    stickyToolbar.appendChild(leftScroll);
    stickyToolbar.appendChild(rightScroll);

    scrollingContainer.addEventListener("scroll", updateDisabled);

    function updateDisabled() {
        // Update button enabled status based on whether it is possible to scroll.
        leftScroll.disabled = scrollingContainer.scrollLeft === 0;
        rightScroll.disabled = scrollingContainer.scrollLeft ===
            scrollingContainer.scrollWidth - scrollingContainer.clientWidth;

        // No point showing either buttons on the toolbar if all the buttons are disabled.
        stickyToolbar.style.display = leftScroll.disabled && rightScroll.disabled ? "none" : undefined;
    }

    updateDisabled();

    return stickyToolbar;
}
